import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import React from "react";
import { Exercise } from "../../../models/Exercise";
import TicketsPoolInline from "./TicketsPoolInline";

const WARSAW_TZ = "Europe/Warsaw";

function formatExerciseClock(timeMs: number): string {
  return format(utcToZonedTime(timeMs, WARSAW_TZ), "HH:mm");
}

function remainingPlaces(item: Exercise): number {
  return item.capacity - (item.prereservation + item.reserved);
}

export function slotIsAvailable(item: Exercise): boolean {
  return item.capacity > item.reserved + item.prereservation;
}

/** Wyprzedany slot bez zakresu godzin: zawsze pokazywaliśmy licznik (np. 0) — zachowanie legacy. */
function showSoldOutPoolWithoutEndTime(showEndTime: boolean | undefined): boolean {
  return !showEndTime;
}

export interface ExerciseSlotLabelProps {
  item: Exercise;
  showEndTime: boolean | undefined;
  showTicketsPool: boolean;
  variant: "available" | "soldOut";
  selectedInBasket?: number;
}

const ExerciseSlotLabel: React.FC<ExerciseSlotLabelProps> = ({
  item,
  showEndTime,
  showTicketsPool,
  variant,
  selectedInBasket = 0,
}) => {
  const rem = remainingPlaces(item);
  const displayRemaining = variant === "soldOut" ? Math.max(0, rem) : rem;

  let pool: React.ReactNode = null;
  if (variant === "available") {
    if (showTicketsPool) {
      pool = <TicketsPoolInline remaining={displayRemaining} selectedInBasket={selectedInBasket} />;
    }
  } else if (showTicketsPool || showSoldOutPoolWithoutEndTime(showEndTime)) {
    pool = <TicketsPoolInline remaining={displayRemaining} />;
  }

  return (
    <b className="flex-between-center">
      {formatExerciseClock(item.startTime)}
      {showEndTime && <> - {formatExerciseClock(item.closeTime)}</>}
      {pool}
    </b>
  );
};

export default ExerciseSlotLabel;
